function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getClient } from '../currentScopes.js';
import { DEBUG_BUILD } from '../debug-build.js';
import { addConsoleInstrumentationHandler } from '../instrument/console.js';
import { defineIntegration } from '../integration.js';
import { SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN } from '../semanticAttributes.js';
import { CONSOLE_LEVELS, debug } from '../utils/debug-logger.js';
import { isPrimitive } from '../utils/is.js';
import { normalize } from '../utils/normalize.js';
import { GLOBAL_OBJ } from '../utils/worldwide.js';
import { _INTERNAL_captureLog } from './exports.js';
var INTEGRATION_NAME = 'ConsoleLogs';
var DEFAULT_ATTRIBUTES = _defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.console.logging');
var _consoleLoggingIntegration = function _consoleLoggingIntegration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var levels = options.levels || CONSOLE_LEVELS;
  return {
    name: INTEGRATION_NAME,
    setup: function setup(client) {
      var _client$getOptions = client.getOptions(),
        _experiments = _client$getOptions._experiments,
        _client$getOptions$no = _client$getOptions.normalizeDepth,
        normalizeDepth = _client$getOptions$no === void 0 ? 3 : _client$getOptions$no,
        _client$getOptions$no2 = _client$getOptions.normalizeMaxBreadth,
        normalizeMaxBreadth = _client$getOptions$no2 === void 0 ? 1000 : _client$getOptions$no2;
      if (!(_experiments !== null && _experiments !== void 0 && _experiments.enableLogs)) {
        DEBUG_BUILD && debug.warn('`_experiments.enableLogs` is not enabled, ConsoleLogs integration disabled');
        return;
      }
      addConsoleInstrumentationHandler(function (_ref) {
        var args = _ref.args,
          level = _ref.level;
        if (getClient() !== client || !levels.includes(level)) {
          return;
        }
        if (level === 'assert') {
          if (!args[0]) {
            var followingArgs = args.slice(1);
            var assertionMessage = followingArgs.length > 0 ? "Assertion failed: ".concat(formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)) : 'Assertion failed';
            _INTERNAL_captureLog({
              level: 'error',
              message: assertionMessage,
              attributes: DEFAULT_ATTRIBUTES
            });
          }
          return;
        }
        var isLevelLog = level === 'log';
        _INTERNAL_captureLog({
          level: isLevelLog ? 'info' : level,
          message: formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
          severityNumber: isLevelLog ? 10 : undefined,
          attributes: DEFAULT_ATTRIBUTES
        });
      });
    }
  };
};

/**
 * Captures calls to the `console` API as logs in Sentry. Requires `_experiments.enableLogs` to be enabled.
 *
 * @experimental This feature is experimental and may be changed or removed in future versions.
 *
 * By default the integration instruments `console.debug`, `console.info`, `console.warn`, `console.error`,
 * `console.log`, `console.trace`, and `console.assert`. You can use the `levels` option to customize which
 * levels are captured.
 *
 * @example
 *
 * ```ts
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   integrations: [Sentry.consoleLoggingIntegration({ levels: ['error', 'warn'] })],
 * });
 * ```
 */
var consoleLoggingIntegration = defineIntegration(_consoleLoggingIntegration);
function formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
  var _GLOBAL_OBJ$util;
  return 'util' in GLOBAL_OBJ && typeof GLOBAL_OBJ.util.format === 'function' ? (_GLOBAL_OBJ$util = GLOBAL_OBJ.util).format.apply(_GLOBAL_OBJ$util, _toConsumableArray(values)) : safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
function safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
  return values.map(function (value) {
    return isPrimitive(value) ? String(value) : JSON.stringify(normalize(value, normalizeDepth, normalizeMaxBreadth));
  }).join(' ');
}
export { consoleLoggingIntegration };